'use client'

import React from 'react'

import { cn } from '@src/utils/tailwind'

interface RadioSelectProps extends React.HTMLProps<HTMLInputElement> {
  facetKey?: string
  index?: number
  header?: string | TrustedHTML
  description?: string
  disclaimer?: string
  label?: string
  finalPrice: string
  strikedPrice?: string
  isAvailable?: boolean
  isSelected?: boolean
}
export const RadioSelect: React.FC<RadioSelectProps> = ({
  facetKey,
  index,
  label,
  description,
  disclaimer,
  header,
  finalPrice: price,
  strikedPrice,
  className,
  isAvailable,
  isSelected,
  ...inputProps
}) => {
  return (
    <label
      data-testid={`${facetKey}Option${index}`}
      className={cn(
        'group flex w-full cursor-pointer flex-col justify-between overflow-hidden rounded-lg border border-bodi-gray-butters transition-all has-[:checked]:border-bodi-black hover:border-bodi-black',
        {
          'border-dashed grayscale text-bodi-gray-butters border-bodi-gray-butters': !isAvailable,
        },
        { 'border-2': isSelected },
        className
      )}
      htmlFor={inputProps.id}
    >
      {header && (
        <div className="flex h-7 w-full items-center justify-center bg-bodi-gray-pearl text-center text-body-base font-semibold uppercase text-bodi-green-deep-500 transition-all group-has-[:checked]:bg-bodi-green-deep-500 group-has-[:checked]:text-bodi-white">
          <span className="prose" dangerouslySetInnerHTML={{ __html: header }} />
        </div>
      )}
      <div className="grid p-4">
        <div className="flex justify-between text-body-md font-medium">
          <div className="flex items-center gap-3">
            <input type="radio" className="peer hidden" {...inputProps} />
            <div className="relative flex size-5 cursor-pointer items-center justify-center rounded-full border-2 border-bodi-gray-butters bg-bodi-gray-pearl peer-checked:z-10 peer-checked:border-bodi-green-deep-500 peer-checked:bg-white">
              <div className="relative -z-10 size-[10px] rounded-full bg-bodi-input-selected"></div>
            </div>
            {label}
          </div>
          <div className="flex gap-2">
            {strikedPrice && isAvailable && (
              <div className="text-bodi-gray-disabled line-through">{strikedPrice}</div>
            )}
            {price && isAvailable && <div className="text-bodi-black-text">{price}</div>}
          </div>
        </div>
        {description && (
          <div className="flex">
            <span
              className="prose text-body-sm"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </div>
        )}
        {disclaimer && <p className="pl-6 text-body-xs text-bodi-gray-medium">{disclaimer}</p>}
      </div>
    </label>
  )
}
